import { LivePayPageLayout } from '@repo/ccc-main-app-lib/src/pages/LivePayPageLayout.tsx'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/user/$userId/live-pay')({
  component: LivePayPageLayoutRoute,
})

function LivePayPageLayoutRoute() {
  const { userId } = Route.useParams()

  return (
    <LivePayPageLayout userId={userId}>
      <Outlet />
    </LivePayPageLayout>
  )
}
